module.exports = __webpack_public_path__ + "img/VL_03_03.82a5d97f.png";